import React, { useEffect, useState } from 'react';
import './AccountDeletionPage.css';
import Footer from '../components/Footer';

const AccountDeletionPage = () => {
    const [requestReceived, setRequestReceived] = useState(false);

    useEffect(() => {
        document.title = 'Account deletion request for animix - Библиотека аниме';
    }, []);

    const handleSubmit = (event) => {
        event.preventDefault();
        setRequestReceived(true);
        event.currentTarget.reset();
    };

    return (
        <div className="account-deletion-shell">
            <main className="account-deletion-page">
                <section className="account-deletion-card" aria-labelledby="account-deletion-title">
                    <div className="account-deletion-language" lang="en">
                        <h1 id="account-deletion-title">
                            Account deletion request for animix - Библиотека аниме
                        </h1>

                        <div className="account-deletion-details" aria-label="Application details">
                            <p><strong>App name:</strong> animix - Библиотека аниме</p>
                            <p><strong>Package name:</strong> lol.animix.app</p>
                            <p><strong>Developer:</strong> Open Initiatives Group</p>
                        </div>

                        <p>
                            This page allows users of animix - Библиотека аниме (lol.animix.app),
                            developed by Open Initiatives Group, to request deletion of their account
                            and associated personal data.
                        </p>

                        <p>
                            To request account deletion, please submit the form below using the email
                            address or username associated with your animix account.
                        </p>

                        <p>
                            We may contact you to verify account ownership before deleting the account.
                        </p>

                        <p>
                            After verification, we will delete your account and associated personal
                            data, unless we are required to retain certain information for legal,
                            security, fraud prevention, or abuse prevention reasons.
                        </p>

                        <form className="account-deletion-form" onSubmit={handleSubmit}>
                            <div className="account-deletion-field">
                                <label htmlFor="account-deletion-username">Username</label>
                                <input
                                    id="account-deletion-username"
                                    name="username"
                                    type="text"
                                    autoComplete="username"
                                    required
                                />
                            </div>

                            <div className="account-deletion-field">
                                <label htmlFor="account-deletion-email">Email address</label>
                                <input
                                    id="account-deletion-email"
                                    name="email"
                                    type="email"
                                    autoComplete="email"
                                    required
                                />
                            </div>

                            <div className="account-deletion-field">
                                <label htmlFor="account-deletion-reason">
                                    Reason for deletion (optional)
                                </label>
                                <textarea id="account-deletion-reason" name="reason" />
                            </div>

                            <button className="account-deletion-submit" type="submit">
                                Request account deletion
                            </button>

                            {requestReceived ? (
                                <p className="account-deletion-message" role="status" aria-live="polite">
                                    Your account deletion request has been received. We may contact you
                                    to verify account ownership before deleting your account.
                                </p>
                            ) : null}
                        </form>
                    </div>

                    <div className="account-deletion-language" lang="ru">
                        <h2>Запрос на удаление аккаунта</h2>

                        <p>
                            Эта страница позволяет пользователям animix - Библиотека аниме
                            (lol.animix.app), разработанного Open Initiatives Group, запросить удаление
                            аккаунта и связанных персональных данных.
                        </p>

                        <p>
                            Чтобы запросить удаление аккаунта, отправьте форму выше, используя
                            email-адрес или имя пользователя, связанные с вашим аккаунтом animix.
                        </p>

                        <p>
                            Мы можем связаться с вами для подтверждения владения аккаунтом перед его
                            удалением.
                        </p>

                        <p>
                            После подтверждения мы удалим ваш аккаунт и связанные персональные данные,
                            если только мы не обязаны сохранить определенную информацию по юридическим
                            причинам, причинам безопасности, предотвращения мошенничества или
                            предотвращения злоупотреблений.
                        </p>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
};

export default AccountDeletionPage;
